import { createLucideIcon } from 'lucide-react'

export const InfoSquare = createLucideIcon('InfoSquare', [
  [
    'path',
    {
      d: 'M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z',
      key: 'InfoSquare-0',
    },
  ],
  [
    'path',
    {
      d: 'M12 16V12',
      key: 'InfoSquare-1',
    },
  ],
  [
    'path',
    {
      d: 'M12.125 8.25H12M12.25 8.25C12.25 8.11193 12.1381 8 12 8C11.8619 8 11.75 8.11193 11.75 8.25C11.75 8.38807 11.8619 8.5 12 8.5C12.1381 8.5 12.25 8.38807 12.25 8.25Z',
      key: 'InfoSquare-2',
    },
  ],
])

InfoSquare.displayName = 'InfoSquare'
